(() => {
  'use strict';

  const parseNumber = (label, fallback) => {
    const match = String(label || '').replace(',', '.').match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : fallback;
  };

  const formatValue = (value, unit) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return '—';
    const displayNumber = unit === 'cm' ? number / 10 : number;
    const formatted = Number.isInteger(displayNumber)
      ? String(displayNumber)
      : displayNumber.toLocaleString('nl-NL', { maximumFractionDigits: 1 });
    return unit ? `${formatted} ${unit}` : formatted;
  };

  const initRange = (root) => {
    if (root.dataset.pwRangeReady === 'true') return;
    root.dataset.pwRangeReady = 'true';

    const minSlider = root.querySelector('[data-pw-range-slider="min"]');
    const maxSlider = root.querySelector('[data-pw-range-slider="max"]');
    const minLabel = root.querySelector('[data-pw-range-min-label]');
    const maxLabel = root.querySelector('[data-pw-range-max-label]');
    const unit = root.dataset.pwRangeUnit || '';
    const values = [...root.querySelectorAll('[data-pw-range-value]')]
      .sort((a, b) => parseNumber(a.dataset.pwRangeLabel, 0) - parseNumber(b.dataset.pwRangeLabel, 0));

    if (!minSlider || !maxSlider || values.length < 2) return;

    const maxIndex = values.length - 1;
    const activeIndexes = values
      .map((input, index) => input.checked ? index : -1)
      .filter((index) => index >= 0);
    let lower = activeIndexes.length ? Math.min(...activeIndexes) : 0;
    let upper = activeIndexes.length ? Math.max(...activeIndexes) : maxIndex;

    minSlider.max = String(maxIndex);
    maxSlider.max = String(maxIndex);
    minSlider.value = String(lower);
    maxSlider.value = String(upper);

    const update = (event) => {
      lower = Number(minSlider.value);
      upper = Number(maxSlider.value);
      if (lower > upper) {
        if (event?.target === minSlider) upper = lower;
        else lower = upper;
      }
      minSlider.value = String(lower);
      maxSlider.value = String(upper);
      values.forEach((input, index) => {
        input.checked = index >= lower && index <= upper;
      });

      const start = maxIndex ? (lower / maxIndex) * 100 : 0;
      const end = maxIndex ? (upper / maxIndex) * 100 : 100;
      root.style.setProperty('--pw-range-start', `${start}%`);
      root.style.setProperty('--pw-range-end', `${end}%`);
      root.toggleAttribute('data-pw-range-active', lower > 0 || upper < maxIndex);
      minLabel.textContent = formatValue(parseNumber(values[lower].dataset.pwRangeLabel, lower), unit);
      maxLabel.textContent = formatValue(parseNumber(values[upper].dataset.pwRangeLabel, upper), unit);
    };

    minSlider.addEventListener('input', update);
    maxSlider.addEventListener('input', update);
    update();
  };

  const initAll = () => document.querySelectorAll('[data-pw-filter-range]').forEach(initRange);

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('on:facet-filters:updated', initAll);
})();
